import {BREAK_POINTS} from '../settings';

export default function() {
  //会員登録フォームに見出し追加
	const root = document.getElementById('wpmem_reg');
	const isProfilePage = document.getElementById('wpmem_profile_form');
	if(!root) {
		return false;
	}
	const fieldset = root.querySelector('fieldset');
	const groups = root.querySelectorAll('.field-group');

	let appendElmIndex = [0,3,9,14,19];
	if(isProfilePage) {
		appendElmIndex = [0,1,7,12,17];
	}
	const headingTexts = [
		"「帰国生のミカタ」無料会員ログイン情報登録",
		"保護者情報",
		"お子様の情報（1人目）",
		"お子様の情報（2人目）",
		"お子様の情報（3人目）",
	];
	let appendElmAttnIndex = [9];
	if(isProfilePage) {
		appendElmAttnIndex = [7];
	}
	const attnTexts = [
		"「以下お子様の情報（1人目）」は必須でお願いします。"
	];

	//子供2人目3人目を非表示に
	groups.forEach((item,i) => {
		let end = groups.length - 1;
		if(isProfilePage) {
			end = groups.length;
		}
		if(i >= appendElmIndex[3] && i < end) {
			item.classList.add('u-hide');
		}
	});

	if(document.getElementById('wpmem_register_form')) {
		groups[groups.length-1].classList.remove('field-group');
		groups[groups.length-1].classList.add('field-agree');
	}

	let attnTextCount = 0;
		appendElmIndex.forEach((v,i) => {
		if(appendElmAttnIndex[attnTextCount] && appendElmAttnIndex[attnTextCount] == appendElmAttnIndex[i]) {
			const p = document.createElement('p');
			p.className = "c-form__attntxt";
			const attntxt = document.createTextNode(attnTexts[attnTextCount]);
			p.appendChild(attntxt);
			fieldset.insertBefore(p, groups[appendElmAttnIndex[attnTextCount]]);
			attnTextCount += 1;
		}
		const hdr = document.createElement('header');
		hdr.className = "c-hdr-h";
		const h = document.createElement('h2');
		//子供2人目3人目を非表示の表示切り替え
		if(i == 3 || i == 4) {
			hdr.classList.add('is-accr-btn');
		}
		h.className = "c-hdr-h__ttl";
		const txt = document.createTextNode(headingTexts[i]);
		h.appendChild(txt);
		hdr.appendChild(h);
		fieldset.insertBefore(hdr, groups[appendElmIndex[i]]);
	});

	document.onclick = function(event) {
		let target = event.target;
		if(!target.classList.contains('is-accr-btn')) {
			target = target.closest('.is-accr-btn');
		}
		if(target) {
			if(target.classList.contains('is')) {
				target.classList.remove('is');
			} else {
				target.classList.add('is');
			}
			let nextEl;
			for(let i = 0; i <= 10; i ++) {
				if(!nextEl) {
					nextEl = target.nextElementSibling;
				} else {
					nextEl = nextEl.nextElementSibling;
				}
				if(nextEl.classList.contains('field-group')) {
					if(nextEl.classList.contains('u-hide')) {
						nextEl.classList.remove('u-hide')
					} else {
						nextEl.classList.add('u-hide')
					}
				} else {
					break;
				}
			}
		}
	};

	// const accrBtns = document.querySelectorAll('.is-accr-btn');
	// accrBtns.forEach( (btn,i) => {
	// 	btn.onclick = (e) => {
	// 		e.stopPropagation();
	// 		console.log(e);
	// 		const el = e.currentTarget;
	// 	}
	// });
	return true;
}
